import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import type {
  HookFormValidate_Type,
  HookTableCustomFilter_ReturnType,
  HookTableCustomFilter_Type,
  HookTableRowFnCan_Type,
  HookTableRowFn_Type,
} from "../../../../../../../_ovlclient/src/global/hooks"
import {
  DialogOkCancel,
  DialogOpen,
} from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import { FieldIsValid } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

import {
  ProcessEnd,
  ProcessIsRunning,
  ProcessStart,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"
import {
  TableGet,
  TableRefresh,
} from "../../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (
  value,
  { global }
) => {
  switch (value.field.fieldKey) {
    case "U_WrapHeight":
    case "U_WrapWidth":
    case "U_WrapLength":
      if (FieldIsValid(value.field)) {
        value.validatorUse("Mandatory")
      }
      break
  }
}

const HookTableCustom_NotFinished_Filter: SYSAction<
  HookTableCustomFilter_Type,
  HookTableCustomFilter_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return !value.row["U_WrapHeight"]
}

const HookTableRowFn: SYSAction<HookTableRowFn_Type> = async (
  value,
  { global }
) => {
  switch (value.fnKey) {
    case "PrintLabel":
      try {
        let state = global.getState()
        ProcessStart("PKGPackagingPackagingPrintLabel")
        await Data("packaging/printlabel", value.data.data[value.rowKey].Code)
        await new Promise((r) => setTimeout(r, 10000))
        return { executeDefaultAction: true }
      } finally {
        ProcessEnd("PKGPackagingPackagingPrintLabel")
      }
      break
    case "OpenSplit":
      await TableRefresh("PKGPackagingSplit", {
        forcedFilters: {
          staticFilter: {
            U_OrderDocEntry: value.row.U_OrderDocEntry,
            U_Unit: value.row.U_Unit,
          },
        },
        resetStrategy: { Selection: true, Filter: true },
      })
      if (TableGet("PKGPackagingSplit").getKeys().length < 2) {
        SnackAdd(T("PKGPackagingPackagingSplitValidatePosCount"), "Warning")
        return
      }
      DialogOpen("PKGPackagingSplit")
      break

    case "UnSplit":
      if (
        (await DialogOkCancel(T("PKGPackagingPackagingUnSplitConfirm"))) === 2
      ) {
        return
      }

      try {
        ProcessStart("PKGPackagingPackagingUnSplit")
        let res = await Data("packaging/split/unsplit", {
          U_OrderDocEntry: value.row.U_OrderDocEntry,
          U_Unit: value.row.U_Unit,
        })
        TableRefresh("PKGPackaging", {
          serverFilter: { U_OrderDocEntry: res.data.docEntry },
        })
      } finally {
        ProcessEnd("PKGPackagingPackagingUnSplit")
      }

      break
  }
}

const HookTableRowFnCan: SYSAction<HookTableRowFnCan_Type> = (value) => {
  let set = value.set
  set("UnSplit", { visibility: "NotVisible" })
  let unit = value.tableData.data[value.rowKey].U_Unit
  if (unit.endsWith(".1") || unit.endsWith(".2")) {
    let unitBeforeSplit = unit.substring(0, unit.length - 2)
    let checkTable = TableGet("PKGPackaging")
    if (
      !checkTable
        .getKeys()
        .some(
          (s) =>
            checkTable.rows[s]["U_Unit"] === `${unitBeforeSplit}.1.1` ||
            checkTable.rows[s]["U_Unit"] === `${unitBeforeSplit}.2.2`
        )
    ) {
      set("UnSplit", { visibility: "Visible" })
    }
  }

  set("OpenSplit", {
    tooltip: T("PKGPackagingPackagingSplit", value.row["U_Unit"]),
  })

  if (
    !value.tableData.data[value.rowKey].U_WrapHeight ||
    ProcessIsRunning("PKGPackagingPackagingPrintLabel")
  ) {
    set("PrintLabel", { visibility: "Disabled" })
  }
}

export let hooks = {
  HookFormValidate,
  HookTableCustom_NotFinished_Filter,
  HookTableRowFn,
  HookTableRowFnCan,
}
